import { apiClient } from '@/shared/api/apiClient';
import {
  handleRequest,
  type RequestHandlerOptions,
} from '@/shared/api/apiWrapper';
import type { LimitsResponseDto } from '../model';

const getLimits = async (
  baseAsset: string,
  options?: RequestHandlerOptions
) => {
  const request = () => apiClient.get(`/users/limits/${baseAsset}`);
  const response = await handleRequest<LimitsResponseDto>(request, options);
  return response.data;
};

export { getLimits };
